let ctx = null;

const KEY = "tt_sound";
export const soundEnabled = () => localStorage.getItem(KEY) !== "off";
export const setSoundEnabled = (on) => localStorage.setItem(KEY, on ? "on" : "off");

function context() {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

// Browsers only allow audio after a user gesture; call this once from any click/keypress so chimes work later, even with the tab hidden.
export function unlockAudio() {
  try { context(); } catch { /* unsupported */ }
}

export function playChime({ force = false } = {}) {
  if (!force && !soundEnabled()) return false;
  try {
    const c = context();
    if (!c) return false;
    const t = c.currentTime + 0.01;
    [[880, 0], [1174.66, 0.14], [1567.98, 0.28]].forEach(([freq, delay]) => {
      const osc = c.createOscillator();
      const gain = c.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, t + delay);
      gain.gain.exponentialRampToValueAtTime(0.22, t + delay + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + delay + 0.5);
      osc.connect(gain).connect(c.destination);
      osc.start(t + delay);
      osc.stop(t + delay + 0.55);
    });
    return true;
  } catch { return false; }
}
